module.exports = __webpack_public_path__ + "img/p21.24761fca.png";